import { API_endpoints } from "../config";

export const getBlockBookingsEmploy = async (
  blockIds: (number|undefined)[], 
  startDate: Date,
  endDate?: Date| null
): Promise<any> => {
  try {
    const body = {
      Blockids: blockIds, 
      start_date: startDate.toISOString().split('T')[0],
      end_date: endDate?.toISOString().split('T')[0] ??null,
    };

    const response = await fetch(API_endpoints.getBlockBookingsEmploy, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Fehler beim Laden von booking Daten.");
    }
    return await response.json();
  } catch (error) {
    console.error("Fehler beim Laden von booking Daten:", error);
  }
};
